import api from './api';

export const listSites = () => api.get('/sites');
export const createSite = (data) => api.post('/sites', data);
export const updateSite = (id, data) => api.put(`/sites/${id}`, data);
export const deleteSite = (id) => api.delete(`/sites/${id}`);

export const assignEmployeeToSite = (employeeId, site_id) =>
  api.put(`/employees/${employeeId}/site`, { site_id });

export default {
  listSites,
  createSite,
  updateSite,
  deleteSite,
  assignEmployeeToSite,
};
